// LiveStreamChatroomGiftItem.js
'use strict';
import { connect } from 'react-redux';

import getLiveStreamData from '../selector/getLiveStreamData.js';
import getListData from '../selector/getListData.js';
import getGiftData from '../selector/getGiftData.js';
import { livestreamNoticeType } from '../resource/liveStreamConstants.js';

import LiveStreamChatroomGiftItem from '../component/LiveStreamChatroomGiftItem.jsx';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { LIVESTREAM_ANIMATION_GIFTS } from '../RemoteConfigKeys.js';

const mapStateToProps = (state, { streamId }) => {
  const noticeType = livestreamNoticeType.GIFT_NOTICE;
  const giftNoticeIds =
    getListData(state, ['liveStream', streamId, noticeType], 'itemIds') || [];
  const giftNoticeId = giftNoticeIds[0];
  const giftNoticeSelectPath = [streamId, noticeType, giftNoticeId];
  const giftId = getLiveStreamData(state, giftNoticeSelectPath, 'giftId');
  const giftImage = giftId ? getGiftData(state, giftId, 'image') : '';

  const livestreamAnimationGiftList =
    getRemoteConfigData(state, LIVESTREAM_ANIMATION_GIFTS) || [];
  const isAnimationGift = livestreamAnimationGiftList.includes(giftId);

  return {
    giftImage,
    isAnimationGift,
    shouldShowMainAsset: getLiveStreamData(
      state,
      giftNoticeSelectPath,
      'shouldShowMainAsset'
    ),
  };
};

export default connect(mapStateToProps, null)(LiveStreamChatroomGiftItem);
